import { useQueryClient as H, hashKey as w } from "@tanstack/react-query";
import { useRef as m, useEffect as E } from "react";
const a = /* @__PURE__ */ new Map();
function Q({
  queryKey: h,
  broadcastChannel: r = "tanstack-query"
}) {
  const f = H(), i = m(!1), y = m({}), s = w(h);
  E(() => {
    const q = (e) => {
      i.current = !0, e(), i.current = !1;
    };
    let u = a.get(r);
    u || (u = { channel: typeof BroadcastChannel < "u" ? new BroadcastChannel(r) : null, count: 0 }, a.set(r, u)), u.count++;
    const c = u.channel, d = f.getQueryCache(), p = (e, t) => {
      const n = Date.now(), o = y.current[s] || 0;
      if (e === "updated" && n - o < 100) return;
      y.current[s] = n;
      const v = e === "updated" && t !== void 0 ? { type: "updated", queryHash: s, state: t } : { type: "removed", queryHash: s };
      c && c.postMessage(v);
    }, g = d.subscribe((e) => {
      if (i.current) return;
      const {
        query: { queryHash: t, state: n }
      } = e;
      t === s && (e.type === "updated" && e.action.type === "success" && p("updated", structuredClone(n)), e.type === "removed" && p("removed"));
    }), l = (e) => {
      const t = e.data;
      t.queryHash === s && q(() => {
        const n = d.get(t.queryHash);
        if (n)
          if (t.type === "updated") {
            const o = t.state;
            o.dataUpdatedAt > n.state.dataUpdatedAt && n.setState(o);
          } else t.type === "removed" && d.remove(n);
      });
    };
    return c && c.addEventListener("message", l), () => {
      var t;
      g(), c && c.removeEventListener("message", l);
      const e = a.get(r);
      e.count--, e.count === 0 && ((t = e.channel) == null || t.close(), a.delete(r));
    };
  }, [f, r, s]);
}
export {
  Q as useBroadcastQuery
};
